import MpBaseWidget from '../../MpBaseWidget.js';

export default class MpHtmlEditor extends MpBaseWidget {

	/** @type {string} */
	static NAME = 'MpHtmlEditor';

	/**
	 * @type {DynamicWidgetConfig}
	 */
	static config = {
		name: 'html-editor', // must match the parent folder name
		optionsDataName: 'htmlEditor', // js data name
		selector: 'textarea[data-html-editor]', // css selector
		sideEffects: false,
		allowReInit: true,
	};

	/**
	 * @protected
	 *
	 * @param {JQuery} $element
	 */
	static addCustomHandlersBefore($element) {

		$element.on(`disable.bind-change-action.${this.getEventNs()}`, async (e, { disabled }) => {

			/** @type {import('tinymce').Editor} */
			const editor = await this.getInstanceRef($element);

			$element.prop('disabled', disabled);

			if (disabled) {
				editor.mode.set('readonly');
			}
			else {

				const privateData = $element.data() || {};

				// Editor lazy loaded
				if (privateData._showEditor) {
					privateData._showEditor((editor) => {
						if (($element.prop('readOnly') !== true) && (editor.mode.get() === 'readonly')) {
							editor.mode.set('design');
						}
					});
				}
				// Editor already loaded
				else {
					if (($element.prop('readOnly') !== true) && (editor.mode.get() === 'readonly')) {
						editor.mode.set('design');
					}
				}
			}
		});
	}
}